<script setup lang="ts">
import type { HTMLAttributes, StyleValue } from 'vue'
import { computed } from 'vue'
import { cn } from '@/ui/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  pinned?: 'left' | 'right'
  pinnedOffset?: number
  pinnedWidth?: number
}>()

const pinnedStyle = computed<StyleValue>(() => {
  if (!props.pinned) return {}
  return {
    [props.pinned]: `${props.pinnedOffset ?? 0}px`,
    ...(props.pinnedWidth ? { width: `${props.pinnedWidth}px`, minWidth: `${props.pinnedWidth}px` } : {})
  }
})
</script>

<template>
  <td
    data-slot="table-cell"
    :class="
      cn(
        'p-2 align-middle text-sm text-foreground whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        pinned && 'sticky z-10 bg-background',
        pinned === 'left' && 'border-r',
        pinned === 'right' && 'border-l',
        props.class
      )
    "
    :style="pinnedStyle"
  >
    <slot />
  </td>
</template>
